var _circle, _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDollarCoin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-inline--fa fa-fw",
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10,
    r: 7.5,
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5833 7.56945L12.5563 7.54689C12.1968 7.24737 11.7438 7.08334 11.2759 7.08334H9.45833C8.65292 7.08334 8 7.73625 8 8.54167V8.54167C8 9.34708 8.65292 10 9.45833 10H11.5417C12.3471 10 13 10.6529 13 11.4583V11.4583C13 12.2638 12.3471 12.9167 11.5417 12.9167H9.19736C8.75018 12.9167 8.32063 12.7423 8 12.4306V12.4306",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 6.66667L10.5 5.83334",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 14.1667V13.3333",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarCoin);
export default "data:image/svg+xml;base64,PHN2ZyBjbGFzc05hbWU9InN2Zy1pbmxpbmUtLWZhIGZhLWZ3IiB2aWV3Qm94PSIwIDAgMjEgMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxjaXJjbGUgY3g9IjEwLjUiIGN5PSIxMCIgcj0iNy41IiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xMi41ODMzIDcuNTY5NDVMMTIuNTU2MyA3LjU0Njg5QzEyLjE5NjggNy4yNDczNyAxMS43NDM4IDcuMDgzMzQgMTEuMjc1OSA3LjA4MzM0SDkuNDU4MzNDOC42NTI5MiA3LjA4MzM0IDggNy43MzYyNSA4IDguNTQxNjdWOC41NDE2N0M4IDkuMzQ3MDggOC42NTI5MiAxMCA5LjQ1ODMzIDEwSDExLjU0MTdDMTIuMzQ3MSAxMCAxMyAxMC42NTI5IDEzIDExLjQ1ODNWMTEuNDU4M0MxMyAxMi4yNjM4IDEyLjM0NzEgMTIuOTE2NyAxMS41NDE3IDEyLjkxNjdIOS4xOTczNkM4Ljc1MDE4IDEyLjkxNjcgOC4zMjA2MyAxMi43NDIzIDggMTIuNDMwNlYxMi40MzA2IiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xMC41IDYuNjY2NjdMMTAuNSA1LjgzMzM0IiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xMC41IDE0LjE2NjdWMTMuMzMzMyIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };